module.exports = __webpack_public_path__ + "static/media/05_car_control.8f6ab39c.gif";